/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

// @ts-expect-error no ts for this repo yet
import { isAssignmentUpdateMessage } from 'conversations-message-history/assignment-update-message/operators/isAssignmentUpdateMessage';
import { client } from 'conversations-inbox-lib/data-fetching-client/public/clients';
export const handleThreadMessage = ({
  data: message
}) => {
  if (isAssignmentUpdateMessage(message)) {
    client.refetchQueries({
      include: ['fetchCurrentAssignee']
    });
  }
};